import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AppSettings } from 'src/app/app.settings';

export interface IProduct {
  id: string;
  stripeProductId: string;
  name: string;
  description: string;
  metadata?: Record<string, unknown>;
  billingCycleId: number;
  billingDay?: number;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
}

@Injectable({
  providedIn: 'root',
})
export class StripeProductsService {
  constructor(private baseRestAngular: Restangular, private restAngular: Restangular) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withConfig((RestangularConfigurer: any) => {
      RestangularConfigurer.setBaseUrl(AppSettings.getProductsEndpoint());
    });
  }
  /**
   * Fetches all active products from the Stripe using products API.
   * @returns Promise<IProduct[]> - A promise that resolves to an array of products.
   */
  getActiveProducts(): Promise<
    { success: true; data: IProduct[] } | { success: false; error: any }
  > {
    return this.restAngular.one('products').customGET('', { onlyActive: true }).toPromise();
  }
}
